import React, { useEffect, useState } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useAuth } from '../AuthContext';
import { auth } from "../Firebase/FirebaseConfig"

export default function Navbar() {
    const { isAuthenticated, hasCertificate, logout } = useAuth();
    const navigate = useNavigate();
    const userName = localStorage.getItem("userName");

   
    const getUserId = () => {
        let storedUserId = localStorage.getItem('userid');
        if (!storedUserId || !isAuthenticated) {
            storedUserId = '40ce1dca-5c9d-5908-b4bb-5a25c5274184';
            localStorage.setItem('userid', storedUserId);
        }
        return storedUserId;
    };

    const userId = getUserId();
    


    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
    }, []);


    const signOut = async () => {
        try {
            await auth.signOut();
            window.location.href = "/login";
            logout();
            localStorage.removeItem('userid');
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('UserName');
            navigate('/login');
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };
    const closeAccordion = () => {
        const el = document.getElementById("navbarSupportedContent");
        if (el) {
            const collapseInstance = window.bootstrap.Collapse.getInstance(el) ||
                new window.bootstrap.Collapse(el, { toggle: false });
            collapseInstance.hide();
        }
    };


    return (
        <div className="main-navigation">
            <nav className="navbar navbar-expand-lg newNabvar">
                <div className="container space-container position-relative">
                    <button className="home-icon mobile-view" type="button" data-bs-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/home">
                            <svg xmlns="http://www.w3.org/2000/svg" width="19.856" height="21.844" viewBox="0 0 19.856 21.844">
                                <path id="Path_104854" data-name="Path 104854" d="M-760.018-465.618q0,3.095,0,6.189c0,.841-.27,1.106-1.119,1.106q-2.341,0-4.682,0c-.808,0-1.09-.278-1.092-1.1q-.007-3.531,0-7.062c0-.643,0-.643-.63-.642H-772.5c-.482,0-.521.032-.521.518,0,2.354,0,4.708,0,7.062a3.01,3.01,0,0,1-.059.628.706.706,0,0,1-.741.591q-2.618.015-5.237,0a.707.707,0,0,1-.745-.629,2.663,2.663,0,0,1-.051-.55c0-4.086,0-8.173-.007-12.259a1.549,1.549,0,0,1,.636-1.318c2.817-2.245,5.618-4.509,8.425-6.767.53-.427.82-.414,1.365.011q3,2.334,6,4.655c.969.751,1.933,1.51,2.91,2.252a1.248,1.248,0,0,1,.52,1.087C-760.025-469.771-760.018-467.694-760.018-465.618Z" transform="translate(779.869 480.166)" fill="#fff" />
                            </svg>
                        </NavLink>
                    </button>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#fff"><path d="M120-240v-66.67h720V-240H120Zm0-206.67v-66.66h720v66.66H120Zm0-206.66V-720h720v66.67H120Z" /></svg>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item dropdown catagories desktop-view">
                                <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/home">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19.856" height="21.844" viewBox="0 0 19.856 21.844">
                                        <path id="Path_104854" data-name="Path 104854" d="M-760.018-465.618q0,3.095,0,6.189c0,.841-.27,1.106-1.119,1.106q-2.341,0-4.682,0c-.808,0-1.09-.278-1.092-1.1q-.007-3.531,0-7.062c0-.643,0-.643-.63-.642H-772.5c-.482,0-.521.032-.521.518,0,2.354,0,4.708,0,7.062a3.01,3.01,0,0,1-.059.628.706.706,0,0,1-.741.591q-2.618.015-5.237,0a.707.707,0,0,1-.745-.629,2.663,2.663,0,0,1-.051-.55c0-4.086,0-8.173-.007-12.259a1.549,1.549,0,0,1,.636-1.318c2.817-2.245,5.618-4.509,8.425-6.767.53-.427.82-.414,1.365.011q3,2.334,6,4.655c.969.751,1.933,1.51,2.91,2.252a1.248,1.248,0,0,1,.52,1.087C-760.025-469.771-760.018-467.694-760.018-465.618Z" transform="translate(779.869 480.166)" fill="#fff" />
                                    </svg>
                                </NavLink>
                            </li>
                            <div className="accordion mobile-view" id="accordionExample">
                                <div className="">
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            <ul className="" id="mobileMainAccordion">
                                                <li><NavLink to="/about" onClick={closeAccordion} >About Us</NavLink></li>
                                                <li className="accordion mobile_accordian_menu" id="catagoryAccordion">
                                                    <button className="accordion-button collapsed mobile-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#catagoryMenu" aria-expanded="false">
                                                        Categories
                                                    </button>
                                                    <div id="catagoryMenu" className="accordion-collapse collapse" data-bs-parent="#mobileMainAccordion">
                                                        <div className="accordion-body p-0">
                                                            <ul className="submenu">
                                                                <li><Link onClick={closeAccordion} to="/popular_books">Popular Books</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/newly_added_books">Newly Added Books</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/books_by_language">Book by Language</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/books_by_age_group">Book by Age Group</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/genre_recommended">Book by Genre</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/video_books">Read Smart</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/verses_wisphers_books">कविताएँ</Link></li>
                                                                <li><Link onClick={closeAccordion} to="/poetry_books">Nursery Rhymes</Link></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="accordion mobile_accordian_menu" id="publisherAccordion">
                                                    <button className="accordion-button collapsed mobile-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#publisherMenu" aria-expanded="false">
                                                        Partners
                                                    </button>
                                                    <div id="publisherMenu" className="accordion-collapse collapse" data-bs-parent="#mobileMainAccordion">
                                                        <div className="accordion-body p-0">
                                                            <ul className="submenu">
                                                                <li><Link to="/author_list" onClick={closeAccordion}>Authors</Link></li>
                                                                <li><Link to="/publisher_list" onClick={closeAccordion}>Publishers</Link></li>
                                                                <li><Link to="/partners" onClick={closeAccordion}>Partner Schools</Link></li>
                                                                <li><Link to="/documents" onClick={closeAccordion}>Important Documents</Link></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                {/* <li><NavLink to="/learn-languages" onClick={closeAccordion} >Learn a New Languages</NavLink></li>
 */}
                                                {/*  {isAuthenticated && (
                                                    <li className="nav-item">
                                                        <NavLink to="/suggestion" onClick={closeAccordion}>
                                                            Wish a Book
                                                        </NavLink>
                                                    </li>
                                                )} */}

                                                <li className="accordion mobile_accordian_menu" id="compAccordion">
                                                    <button className="accordion-button collapsed mobile-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#compMenu" aria-expanded="false">
                                                        Rashtriya Kavya Utsav
                                                    </button>
                                                    <div id="compMenu" className="accordion-collapse collapse" data-bs-parent="#mobileMainAccordion">
                                                        <div className="accordion-body p-0">
                                                            <ul className="submenu">
                                                                <li><Link to="/guide" onClick={closeAccordion}>Step by Step Guide</Link></li>
                                                                <li><Link to="/poem_list_pdf" onClick={closeAccordion}>Poem List</Link></li>
                                                                <li><Link to="/faq" onClick={closeAccordion}>FAQs</Link></li>
                                                                {isAuthenticated && (
                                                                    <li><Link to="/certificate" onClick={closeAccordion}>Download Certificate</Link></li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="accordion mobile_accordian_menu" id="aboutAccordion">
                                                    <button className="accordion-button collapsed mobile-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#aboutMenu" aria-expanded="false">
                                                        Events
                                                    </button>
                                                    <div id="aboutMenu" className="accordion-collapse collapse" data-bs-parent="#mobileMainAccordion">
                                                        <div className="accordion-body p-0">
                                                            <ul className="submenu">
                                                                <li><Link to="/articles" onClick={closeAccordion}>ReP in the News</Link></li>
                                                                <li><Link to="/gallery" onClick={closeAccordion}>Snapshots</Link></li>
                                                                <li><Link to="/camp" onClick={closeAccordion}>Summer Camp</Link></li>
                                                                {/* <li><Link to="/participants_list" onClick={closeAccordion}>Amritkaal Results</Link></li> */}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>

                                                <li className="accordion mobile_accordian_menu" id="digitalAccordion">

                                                    <button className="accordion-button collapsed mobile-accordion-btn" type="button" data-bs-toggle="collapse" data-bs-target="#digitalMenu" aria-expanded="false">
                                                        Digital Resources
                                                    </button>

                                                    <div id="digitalMenu" className="accordion-collapse collapse" data-bs-parent="#mobileMainAccordion">
                                                        <div className="accordion-body p-0">
                                                            <ul className="submenu">
                                                                <li><Link target='_blank' to="https://pmevidya.education.gov.in/">PM e-VIDYA</Link></li>
                                                                <li><Link target='_blank' to="https://diksha.gov.in/">DIKSHA</Link></li>
                                                                <li><Link target='_blank' to="https://ejaaduipitara.ncert.gov.in/">e-Jaadui Pitara</Link></li>
                                                                <li><Link target='_blank' to="https://manodarpan.education.gov.in/">MANODARPAN</Link></li>
                                                                <li><Link target='_blank' to="https://www.ndl.gov.in/">NDLI</Link></li>
                                                                <li><Link target='_blank' to="https://ullas.education.gov.in/nilp">ULLAS</Link></li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </li>

                                                {isAuthenticated && (
                                                    <li className="nav-item">
                                                        <NavLink to="/profile" onClick={closeAccordion}>
                                                            Profile
                                                        </NavLink>
                                                    </li>
                                                )}

                                                {isAuthenticated ? (
                                                    <li className="nav-item">
                                                        <button className='btn-6 view-all-btnn white-btnn' onClick={() => signOut()} >Logout</button>

                                                    </li>

                                                ) : (
                                                    <li className="nav-item">
                                                        <NavLink to="/login" onClick={closeAccordion}>Login / Register</NavLink>
                                                    </li>
                                                )}

                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <li className="nav-item desktop-view dropdown catagories">
                                <NavLink to="/about" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} >
                                    About Us
                                </NavLink>
                            </li>

                            <li className="nav-item desktop-view dropdown catagories">
                                <span className="nav-link">
                                    Categories
                                </span>
                                <ul className="dropdown-position-list">
                                    <li><Link to="/book-category" state={{ title: "Popular Books", tilesTitle: "popular_books", }}>Popular Books</Link></li>
                                    <li><Link to="/book-category" state={{ title: "Newly Added Books", tilesTitle: "newly_added_books", }}>Newly Added Books</Link></li>
                                    <li><Link to="/language">Books by Language</Link></li>
                                    <li className="dropdown doc-anc catagories">
                                        <Link className='' >Books by Age Group</Link>
                                        <ul className="dropdown-position-list doc-nav">
                                            <li><Link to="/book-category" state={{ title: "3 to 8 Years", age_group_id: 1 }}>3 to 8 Years</Link></li>
                                            <li><Link to="/book-category" state={{ title: "8 to 11 Years", age_group_id: 2 }}>8 to 11 Years</Link></li>
                                            <li><Link to="/book-category" state={{ title: "11 to 14 Years", age_group_id: 3 }}>11 to 14 Years</Link></li>
                                            <li><Link to="/book-category" state={{ title: "Young Adults", age_group_id: 4 }}>Young Adults</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to="/genre">Books by Genre</Link></li>
                                    <li><Link to="/book-category" state={{ title: "ReadSmart - Animated Books & Quiz", tilesTitle: "video_book", }}>ReadSmart - Animated Books & Quiz</Link></li>
                                    <li><Link to="/book-category" state={{ title: "कविताएँ", tilesTitle: "verses_and_whispers", }}>कविताएँ</Link></li>
                                    <li><Link to="/book-category" state={{ title: "Rhymes Corner", tilesTitle: "rhymes_corner", }}>Rhymes Corner</Link></li>
                                    <li><Link to="/book-category" state={{ title: "Learn New Language", tilesTitle: "learn_new_language", }}>Learn New Languages</Link></li>
                                </ul>
                            </li>


                            <li className="nav-item desktop-view dropdown catagories">
                                <span className="nav-link">
                                    Partner
                                </span>
                                <ul className="dropdown-position-list">
                                    <li className="dropdown doc-anc catagories">
                                        <Link className='' to="/publishers">Publishers</Link>
                                        <ul className="dropdown-position-list doc-nav">
                                            <li><Link to="/documents">Important Documents</Link></li>
                                        </ul>
                                    </li>
                                    <li><Link to="/authors">Authors</Link></li>
                                    <li><Link to="/partners">Schools</Link></li>

                                </ul>
                            </li>


                            {/* <li className="nav-item desktop-view">
                                <NavLink to="/book-category" state={{ title: "Learn New Language",tilesTitle: "learn_new_language",}} className= "nav-link">
                                    Learn a New Languages
                                </NavLink>
                            </li> */}

                            {/* {isAuthenticated && (
                                <li className="nav-item desktop-view">
                                    <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/suggestion">
                                        Wish a Book
                                    </NavLink>
                                </li>
                            )} */}

                            <li className="nav-item desktop-view dropdown catagories">
                                <span className="nav-link">Rashtriya Kavya Utsav</span>
                                <ul className="dropdown-position-list">
                                    <li><Link to="/guide">Step by Step Guide</Link></li>
                                    <li><Link to="/poem_list_pdf">Poem List</Link></li>
                                    <li><Link to="/faq">FAQs</Link></li>
                                    {isAuthenticated && (
                                        <li>
                                            <Link className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/certificate">
                                                Download Certificate
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </li>

                            <li className="nav-item desktop-view dropdown catagories">
                                <span className="nav-link">
                                    Events
                                </span>
                                <ul className="dropdown-position-list">
                                    <li><Link to="/articles">ReP in the News</Link></li>
                                    <li><Link to="/gallery">Snapshots</Link></li>
                                    <li><Link to="/camp">Summer Camp</Link></li>
                                    {/* <li><Link to="/participants_list">Amritkaal Results</Link></li> */}
                                </ul>
                            </li>

                            {/*  */}

                            <li className="nav-item desktop-view dropdown catagories">
                                <span className="nav-link">
                                    Digital Resources
                                </span>
                                <ul className="dropdown-position-list">
                                    <li><Link target='_blank' to="https://pmevidya.education.gov.in/">PM e-VIDYA</Link></li>
                                    <li><Link target='_blank' to="https://diksha.gov.in/">DIKSHA</Link></li>
                                    <li><Link target='_blank' to="https://ejaaduipitara.ncert.gov.in/">e-Jaadui Pitara</Link></li>
                                    <li><Link target='_blank' to="https://manodarpan.education.gov.in/">MANODARPAN</Link></li>
                                    <li><Link target='_blank' to="https://www.ndl.gov.in/">NDLI</Link></li>
                                    <li><Link target='_blank' to="https://ullas.education.gov.in/nilp">ULLAS</Link></li>
                                </ul>
                            </li>



                            {isAuthenticated ? (
                                <>
                                    <li className="nav-item desktop-view dropdown catagories login-btn">
                                        <span className="nav-link text-capitalize">
                                            Hi, {userName}
                                        </span>
                                        <ul className="dropdown-position-list">
                                            <li><Link to="/profile">Profile</Link></li>
                                            <li><Link onClick={() => signOut()}>Logout</Link></li>

                                        </ul>
                                    </li>

                                </>
                            ) : (
                                <li className="nav-item desktop-view login-btn">
                                    <NavLink to="/login" className="nav-link">Login / Register</NavLink>
                                </li>
                            )}

                        </ul>
                        <div className="d-flex">
                            <div className="dropdown profileTabSec">
                                <button className="dropdown-toggle" type="button" id="profileTab" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src="assets/images/user.png" alt="user" />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="profileTab">
                                    <li><NavLink className="dropdown-item" to="/profile">Profile</NavLink></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}
